import React from 'react';
import { Box } from '@mui/material';
import { Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useTheme, styled } from '@mui/material/styles';
import { Switch } from '@mui/material';
// import gvLogo from '../images/gvLogo.png';
import AppHeader from './AppHeader';

import {
  isSharing,
} from '../../redux/sharingSlice';

import {
  isGrid,
} from '../../redux/challengeSlice';

export default function Settings() {
  const theme = useTheme();

  // const [checked, setChecked] = React.useState(false);

  const sharingState = useSelector((state) => state.sharing.isSharing);
  const isGridState = useSelector((state) => state.challenge.isGrid);

  const dispatch = useDispatch();

  const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          // backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
          backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#60a5fa',

          opacity: 1,
          border: 0,
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#33cf4d',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color:
          theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[600],
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 22,
      height: 22,
    },
    '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
    },
  }));

  const handleChange = (event) => {
    // setChecked(event.target.checked);
    dispatch(isSharing(event.target.checked));
    console.log('Status: ', event.target.checked);
  };

  const handleChangeGrid = (event) => {
    // setChecked(event.target.checked);
    dispatch(isGrid(event.target.checked));
    console.log('Grid Status: ', event.target.checked);
  };

  return (





    <Box
      sx={{
        height: '100%',
        width: '100%',
        backgroundColor: '#3B4E68',
        display: 'flex',
        flexDirection: 'column',
        // justifyContent: 'space-between',
        paddingBottom: '20px',
      }}
    >

      <Box>
        <AppHeader />
      </Box>

      <Typography
        variant='body1'
        sx={{
          color: '#FFFFFF',
          fontSize: '24px',
          fontWeight: 'bold',
          textAlign: 'left',
          paddingLeft: '20px',
        }}
      >
        Settings
      </Typography>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '20px',
        }}>
        <Box
          sx={{
            color: '#FFFFFF',
            textAlign: 'left',
            fontSize: '14px',
            paddingRight: '10px',
          }}
        >
          Help us improve the app by sharing your app usage data
        </Box>
        {/* <Switch
                checked={checked}
                onChange={handleChange}
              /> */}
        <IOSSwitch
          // checked={checked}
          checked={sharingState}
          onChange={handleChange}
        />
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '20px',
        }}>
        <Box
          sx={{
            color: '#FFFFFF',
            textAlign: 'left',
            fontSize: '14px',
            paddingRight: '10px',
          }}
        >
          *** TESTING *** Use Grid
        </Box>
        <IOSSwitch
          checked={isGridState}
          onChange={handleChangeGrid}
        />
      </Box>

    </Box>

  );
}